// extracted by mini-css-extract-plugin
module.exports = {"root":"ShareButton_root__JsdIZ","input":"ShareButton_input__pcFgB","icon":"ShareButton_icon__1Z_5Q","shareFontStyle":"ShareButton_shareFontStyle__35jXN"};